import { useState } from "react";
import { Mail, Loader2, Check } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import api from "../lib/api";
import { toast } from "sonner";

export const NewsletterForm = ({ source = "guida" }) => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");
  const submit = async (e) => {
    e.preventDefault();
    setState("loading");
    try {
      const { data } = await api.post("/newsletter/subscribe", { email, source });
      setState("done");
      toast.success(data.status === "already" ? "Sei già iscritto alla nostra guida" : "Iscrizione confermata, controlla la tua email");
    } catch {
      setState("idle");
      toast.error("Email non valida, riprova");
    }
  };
  return (
    <div className="mt-12 rounded-3xl bg-[#0B2A45] text-white p-8 sm:p-10" data-testid="newsletter-box">
      <div className="eyebrow text-[#FDE047] mb-2 flex items-center gap-2"><Mail className="w-4 h-4" />Newsletter della guida</div>
      <h3 className="font-serif text-2xl sm:text-3xl font-semibold mb-2">Nuovi consigli e offerte, direttamente via email</h3>
      <p className="text-stone-300 text-sm mb-6 max-w-xl">Una email ogni tanto con ricette, consigli per bar e lidi e le nostre offerte. Niente spam.</p>
      {state === "done" ? (
        <div className="flex items-center gap-2 text-[#FDE047] font-semibold" data-testid="newsletter-success"><Check className="w-5 h-5" />Grazie! Ti abbiamo scritto.</div>
      ) : (
        <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 max-w-lg">
          <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="la-tua@email.it"
            className="h-12 rounded-full bg-white text-[#0B2A45] border-0 px-5" data-testid="newsletter-email-input" />
          <Button type="submit" disabled={state === "loading"} className="h-12 rounded-full px-7 bg-[#C2593F] hover:bg-[#9A3412] text-white" data-testid="newsletter-submit-btn">
            {state === "loading" ? <Loader2 className="w-4 h-4 animate-spin" /> : "Iscriviti"}
          </Button>
        </form>
      )}
    </div>
  );
};
